import { render, staticRenderFns } from "./Estatisticas.vue?vue&type=template&id=4cc67013"
import script from "./Estatisticas.vue?vue&type=script&lang=js"
export * from "./Estatisticas.vue?vue&type=script&lang=js"
import style0 from "./Estatisticas.vue?vue&type=style&index=0&id=4cc67013&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports